import { render, staticRenderFns } from "./StaffSelector.vue?vue&type=template&id=53aae76a&scoped=true&"
import script from "./StaffSelector.vue?vue&type=script&lang=js&"
export * from "./StaffSelector.vue?vue&type=script&lang=js&"
import style0 from "./StaffSelector.vue?vue&type=style&index=0&id=53aae76a&lang=scss&scoped=true&"
import style1 from "./StaffSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aae76a",
  null
  
)

export default component.exports